import { ProductCategory, ShippingMode } from '../types';

/**
 * 计算平台佣金
 * @param priceInRub 商品价格（卢布）
 * @param category 商品类别
 * @param shippingMode 发货模式
 * @returns 平台佣金率（小数形式，如0.12表示12%）
 */
export function calculateCommissionRate(
  priceInRub: number,
  category: ProductCategory,
  shippingMode: ShippingMode
): number {
  // 基础佣金率
  let commissionRate: number;
  
  // 根据商品类别和价格设置基础佣金率
  if (category === 'pet') {
    // 宠物用品
    commissionRate = priceInRub < 1500 ? 0.12 : 0.15;
  } else {
    // 工具和其他类别
    commissionRate = priceInRub < 1500 ? 0.12 : 0.18;
  }
  
  // 边境仓模式佣金率减1%
  if (shippingMode === 'border') {
    commissionRate = Math.max(0, commissionRate - 0.01);
  }
  
  return commissionRate;
}

/**
 * 计算平台佣金金额
 * @param priceInRub 商品价格（卢布）
 * @param category 商品类别
 * @param shippingMode 发货模式
 * @returns 平台佣金金额（人民币）
 */
export function calculateCommission(
  priceInRub: number,
  category: ProductCategory,
  shippingMode: ShippingMode
): number {
  const rate = calculateCommissionRate(priceInRub, category, shippingMode);
  // 假设1卢布 = 0.08人民币（实际应根据实时汇率获取）
  const exchangeRate = 0.08;
  return priceInRub * rate * exchangeRate;
}
